/**
 * Converts an alignment score (0-100) to a descriptive text label
 * Matches the backend algorithm in GameInsightService.AglimentScoreToText
 * @param alignmentScore - The alignment score (0-100)
 * @returns A string describing the alignment level
 */
export const alignmentScoreToText = (alignmentScore: number): string => {
    if (alignmentScore < 0) {
        return "Unknown";
    } else if (alignmentScore <= 5) {        // Was 10 - adjusted for new algorithm
        return "Very low";
    } else if (alignmentScore <= 25) {       // Was 30 - adjusted for new algorithm
        return "Low";
    } else if (alignmentScore <= 50) {       // Was 58 - adjusted for new algorithm
        return "Medium";
    } else if (alignmentScore <= 70) {      // Was 70 - adjusted for new algorithm
        return "High";
    } else if (alignmentScore <= 85) {      // Was 99 - adjusted for new algorithm
        return "Very high";
    } else if (alignmentScore === 100) {
        return "Perfect";
    } else {
        return "Unknown";
    }
};

/**
 * Color mapping for alignment score ranges
 * Used for charts and visual indicators
 */
export const ALIGNMENT_SCORE_COLORS = {
    veryLow: "#d32f2f",    // Red
    low: "#ed6c02",         // Orange
    medium: "#fbc02d",      // Yellow
    high: "#2e7d32",        // Green
    veryHigh: "#388e3c",    // Dark Green
    perfect: "#388e3c",     // Dark Green
} as const;

/**
 * Threshold values for alignment score ranges (matching backend logic)
 */
export const ALIGNMENT_SCORE_THRESHOLDS = [0, 5, 25, 50, 70, 85, 100] as const;

/**
 * Determines the color based on the alignment score value
 * @param value - The alignment score (0-100)
 * @returns Hex color code for the score range
 */
export const getAlignmentScoreColor = (value: number): string => {
    if (value <= 5) return ALIGNMENT_SCORE_COLORS.veryLow;
    if (value <= 25) return ALIGNMENT_SCORE_COLORS.low;
    if (value <= 50) return ALIGNMENT_SCORE_COLORS.medium;
    if (value <= 70) return ALIGNMENT_SCORE_COLORS.high;
    if (value <= 85) return ALIGNMENT_SCORE_COLORS.veryHigh;
    return ALIGNMENT_SCORE_COLORS.perfect;
};

